import React, { useState } from "react";

import { Typography } from "@mui/material";
import { Box } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { useAppState } from "../../../../context/StateContext";
import { WidgetFilter } from "../../../../models/widget.filter";
import DashboardService from "../../../../services/dashboard.service";
import { formatThousandsWithComma } from "../../../../util/formatThousandsWithComma";
import { useStyles } from "./styles";

/** Default Functional Component */
export default function ActiveQuotes({ filterInfo }: { filterInfo: WidgetFilter }) {
  const classes = useStyles();
  const { t: translate } = useTranslation();
  const { currentUser } = useAppState();

  const [total, setTotal] = useState<number>(0);

  useQuery(
    ["dashboard.quote.count", filterInfo],
    () =>
      DashboardService.getQuoteCount({
        dateFrom: filterInfo?.dateFrom,
        dateTo: filterInfo?.dateTo,
        companyId: currentUser?.companyId,
      }),
    {
      onSuccess: (response) => {
        if (response && response?.data !== undefined && !Number.isNaN(Number(response?.data))) {
          setTotal(response?.data ? Number(response?.data?.toFixed(2)) : 0);
        }
      },
      enabled: !!currentUser?.companyId,
    }
  );

  return (
    <Box className={classes.root}>
      <Typography className={classes.title} gutterBottom data-cy="activeQuotes">
        {translate("activeQuotes")}
      </Typography>

      <Typography
        className={classes.lblFigures}
        variant="h5"
        component="h2"
        align="left"
        data-cy="activeQuotesTotal"
      >
        {formatThousandsWithComma(String(total))}
      </Typography>
    </Box>
  );
}
